import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-off-duty-code',
  templateUrl: './off-duty-code.component.html',
  styleUrls: ['./off-duty-code.component.css']
})
export class OffDutyCodeComponent implements OnInit {
    public offDutyCodeKeyno;

    public edit?: Edit;

    public selectListSalaryTypes: Item[] = [];

    public selectListColours: ColourItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.offDutyCodeKeyno = this.stateService.getStateParams()['offdutycode_keyno'];
    }

    private async loadEdit() {
        if (!!this.offDutyCodeKeyno) {
            this.edit = (await this.datatask.Post(489, { offdutycode_keyno: this.offDutyCodeKeyno }))[0];
        }
    }

    private async loadSalaryTypes(): Promise<void> {
        this.selectListSalaryTypes = await this.datatask.Post(481);
    }

    private async loadColours(): Promise<void> {
        this.selectListColours = await this.datatask.Post(491);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(490, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(579, { offdutycode_keyno: this.edit.offdutycode_keyno }))[0];

                    if (response?.status_no === '0') this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadSalaryTypes();
        this.loadColours();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    offdutycode_keyno: number;
    offdutycode_name: string;
    offdutycode_id_salaryprogram: string;
    text_color_hex: string;
    background_color_hex: string;
    salarytype_id_pay: string;
    salarytype_id_reduction: string;
    is_new: string;
    show_on_timeregistration: number;
    note_required: number;
}

interface ColourItem {
    hexcolor: string;
    color_name: string;
    orderby: number;
}
